/* src/app/components/companies-components/companies-company-image-card/companies-company-image-card.component.scss */
:host footer > div {
  display: flex;
  flex-direction: column;
}
:host footer > div > img {
  max-width: 100%;
  max-height: 175px;
  height: 100%;
  margin: 0 auto;
  width: auto;
  margin-bottom: 1rem;
}
:host footer > div > app-mb-button {
  align-self: center;
}
/*# sourceMappingURL=companies-company-image-card.component.css.map */
